<template>
  <div class="tabs">
    <!-- verzameling van bovenste tabladen -->
    <div class="tabs__actions">
      <!-- Tablad 1 -->
      <div
        :class="{
          tabs__actions__tab: true,
          'tabs__actions__tab--left': true,
          'tabs__actions__tab--active': selectedIndex === 0,
        }"
        @click="selectedIndex = 0"
      >
        <img
          src="/modules/custom/twin_threesixty/images/kipper-small.png"
          alt=""
          class="tabs__actions__tab--icon"
        />
        <span class="tabs__actions__tab--degrees">51&deg; </span>
      </div>

      <!-- Tablad 2 -->
      <div
        :class="{
          tabs__actions__tab: true,
          'tabs__actions__tab--right': true,
          'tabs__actions__tab--active': selectedIndex === 1,
        }"
        @click="selectedIndex = 1"
      >
        <img
          src="/modules/custom/twin_threesixty/images/transporter-small.png"
          alt=""
          class="tabs__actions__tab--icon"
        />
        <span class="tabs__actions__tab--degrees">11&deg;</span>
      </div>
    </div>

    <!-- De viewer onder de tabladen -->
    <div
      :class="{
        tabs__viewer: true,
        'tabs__viewer--spinner': !fetched,
      }"
    >
      <!--
        het component voor de 360 viewer
        Deze wordt maar 1 keer ingeladen maar adhv het geselecteerde index (van de tabladen)
        worden de nodige hotspots en foto's ingeladen.
        Dit zorgt ervoor dat het component niet 2x gerendered moet worden
        -->
      <div class="loader" v-if="!fetched"></div>
      <ThreeSixty
        :class="{ hidden: !fetched }"
        :fetched="fetched"
        :hotspots="trailers[selectedIndex]"
        :type="selectedIndex === 0 ? 'kipper' : 'transporter'"
      />
    </div>
    <img
      src="https://www.twintrailer.be/modules/custom/twin_threesixty/images/placeholder_blur.jpg"
      class="preload"
    />
    <!-- <img :src="require('@/assets/images/placeholder_blur.jpg')" class="preload" /> -->
    <img
      v-for="num in 24"
      :key="'kipper_preload_' + num"
      :src="
        'https://www.twintrailer.be/modules/custom/twin_threesixty/images/kipper_' +
        num +
        '.jpg'
      "
      class="preload"
    />
    <img
      v-for="num in 24"
      :key="'transporter_preload_' + num"
      :src="
        'https://www.twintrailer.be/modules/custom/twin_threesixty/images/transporter_' +
        num +
        '.jpg'
      "
      class="preload"
    />
  </div>
</template>

<script>
import ThreeSixty from "@/components/ThreeSixty";
import axios from "axios";
export default {
  name: "Tabs",
  components: {
    ThreeSixty,
  },
  data() {
    return {
      selectedIndex: 0,
      fetched: false,
      langCode: "en",
      arr: [],

      // Data met hotspots.
      // Deze staan vast (hardcoded), maar zijn gemakkelijk toe te voegen met developer mode (zie Readme.md)
      trailers: [
        // [0] -> Kipper
        [
          // {x:0, y:0} => geen hotspot tonen
          // Adhv een optie developer mode kan je door te klikken op de foto de onderstaande locaties genereren.
          // Je moet ze niet zelf één voor één schrijven
          {
            field_hotspot_id: "KIPPER_1",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 71.67,
                y: 43.79,
              },
              {
                x: 62.33,
                y: 43.79,
              },
              {
                x: 50.33,
                y: 43.09,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 50.83,
                y: 42.86,
              },
              {
                x: 40.5,
                y: 42.62,
              },
              {
                x: 32.17,
                y: 42.62,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_2",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 59.83,
                y: 40.28,
              },
              {
                x: 61.83,
                y: 39.58,
              },
              {
                x: 41,
                y: 40.75,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_4",
            locations: [
              {
                x: 43.33,
                y: 61.59,
              },
              {
                x: 42.83,
                y: 61.36,
              },
              {
                x: 53.17,
                y: 61.36,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 50.33,
                y: 62.06,
              },
              {
                x: 49.5,
                y: 62.06,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_5",
            locations: [
              {
                x: 55.33,
                y: 63.7,
              },
              {
                x: 46,
                y: 65.11,
              },
              {
                x: 37,
                y: 64.64,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_6",
            locations: [
              {
                x: 60.33,
                y: 69.56,
              },
              {
                x: 49.33,
                y: 69.79,
              },
              {
                x: 40.33,
                y: 69.56,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_7",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 84.33,
                y: 68.38,
              },
              {
                x: 86.17,
                y: 70.02,
              },
              {
                x: 87.67,
                y: 73.3,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_8",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 45.17,
                y: 54.57,
              },
              {
                x: 44.33,
                y: 53.86,
              },
              {
                x: 43.67,
                y: 52.93,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 56.5,
                y: 55.5,
              },
              {
                x: 57,
                y: 52.93,
              },
              {
                x: 56.67,
                y: 53.16,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_9",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 58.17,
                y: 37.94,
              },
              {
                x: 56,
                y: 36.3,
              },
              {
                x: 53.33,
                y: 35.13,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_10",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 26.17,
                y: 70.73,
              },
              {
                x: 20.67,
                y: 68.62,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 80.33,
                y: 64.64,
              },
              {
                x: 80.83,
                y: 64.87,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_11",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 51.33,
                y: 39.11,
              },
              {
                x: 47.67,
                y: 39.34,
              },
              {
                x: 43.83,
                y: 39.11,
              },
              {
                x: 40.17,
                y: 38.41,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 53.5,
                y: 38.64,
              },
              {
                x: 50.5,
                y: 37.94,
              },
              {
                x: 46,
                y: 39.11,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_12",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 52.99,
                y: 43.41,
              },
              {
                x: 51,
                y: 44.01,
              },
              {
                x: 49,
                y: 43.71,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_13",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 67.5,
                y: 62.06,
              },
              {
                x: 65.67,
                y: 62.76,
              },
              {
                x: 62.67,
                y: 63,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_14",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 12,
                y: 64.64,
              },
              {
                x: 7.67,
                y: 62.53,
              },
              {
                x: 7.67,
                y: 60.66,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_15",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 56,
                y: 61.83,
              },
              {
                x: 57,
                y: 61.83,
              },
              {
                x: 55.67,
                y: 61.59,
              },
              {
                x: 53.83,
                y: 61.59,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_16",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 32.83,
                y: 67.21,
              },
              {
                x: 32.17,
                y: 66.28,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_17",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 58.5,
                y: 41.45,
              },
              {
                x: 44.67,
                y: 41.45,
              },
              {
                x: 32,
                y: 41.45,
              },
              {
                x: 22.33,
                y: 41.92,
              },
              {
                x: 15.83,
                y: 42.15,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "KIPPER_3",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 57.17,
                y: 73.07,
              },
              {
                x: 48,
                y: 72.83,
              },
              {
                x: 40.17,
                y: 72.6,
              },
              {
                x: 54.33,
                y: 72.83,
              },
              {
                x: 45,
                y: 73.07,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          // // {
          // //   field_hotspot_id: "KIPPER_5",
          // //   locations: [
          // //   ],
          // // },
        ],
        // [1] -> Transporter
        [
          {
            field_hotspot_id: "TRANSPORTER_1",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 51.83,
                y: 78.69,
              },
              {
                x: 36.67,
                y: 78.45,
              },
              {
                x: 26,
                y: 75.41,
              },
              {
                x: 19,
                y: 73.77,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_2",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 76.33,
                y: 75.18,
              },
              {
                x: 73.5,
                y: 77.05,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 31,
                y: 74,
              },
              {
                x: 29,
                y: 73.07,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_3",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 66.83,
                y: 60.66,
              },
              {
                x: 65.67,
                y: 61.12,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 37.17,
                y: 59.95,
              },
              {
                x: 38,
                y: 59.72,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_4",
            locations: [
              {
                x: 49.83,
                y: 49.65,
              },
              {
                x: 42.83,
                y: 49.65,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 66,
                y: 50.12,
              },
              {
                x: 60,
                y: 49.41,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_5",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 40.83,
                y: 31.62,
              },
              {
                x: 46.33,
                y: 32.55,
              },
              {
                x: 50.17,
                y: 32.79,
              },
              {
                x: 55.5,
                y: 32.08,
              },
              {
                x: 60.83,
                y: 32.08,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_6",
            locations: [
              {
                x: 55,
                y: 56.44,
              },
              {
                x: 46.33,
                y: 55.5,
              },
              {
                x: 37.17,
                y: 55.27,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_7",
            locations: [
              {
                x: 59.83,
                y: 62.3,
              },
              {
                x: 51.33,
                y: 61.83,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 69.33,
                y: 62.06,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_8",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 80,
                y: 68.85,
              },
              {
                x: 73,
                y: 71.19,
              },
              {
                x: 61.83,
                y: 75.41,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_9",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 56.17,
                y: 72.83,
              },
              {
                x: 51.67,
                y: 77.75,
              },
              {
                x: 41.83,
                y: 77.75,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_10",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 29.5,
                y: 63.47,
              },
              {
                x: 28,
                y: 64.17,
              },
              {
                x: 24.83,
                y: 62.76,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 74.83,
                y: 60.19,
              },
              {
                x: 73.5,
                y: 62.76,
              },
              {
                x: 78.33,
                y: 61.36,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_11",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 35,
                y: 68.62,
              },
              {
                x: 27.5,
                y: 67.68,
              },
              {
                x: 23.5,
                y: 65.81,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_12",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 46.67,
                y: 56.91,
              },
              {
                x: 42.83,
                y: 57.38,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 53,
                y: 55.5,
              },
              {
                x: 49.33,
                y: 55.5,
              },
              {
                x: 45.67,
                y: 55.97,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_13",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 52.67,
                y: 59.72,
              },
              {
                x: 51,
                y: 59.72,
              },
              {
                x: 49.5,
                y: 59.72,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_14",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 53.17,
                y: 64.4,
              },
              {
                x: 49,
                y: 64.64,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 53,
                y: 66.28,
              },
              {
                x: 49,
                y: 65.11,
              },
              {
                x: 44.83,
                y: 64.64,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_15",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 12.33,
                y: 63.7,
              },
              {
                x: 7.83,
                y: 62.3,
              },
              {
                x: 7.83,
                y: 59.48,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_16",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 35.17,
                y: 65.57,
              },
              {
                x: 33.83,
                y: 65.57,
              },

              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 67.17,
                y: 64.17,
              },
              {
                x: 68.67,
                y: 66.51,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
          {
            field_hotspot_id: "TRANSPORTER_17",
            locations: [
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 73.83,
                y: 46.14,
              },
              {
                x: 64.33,
                y: 45.2,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 36.67,
                y: 45.67,
              },
              {
                x: 28.33,
                y: 46.6,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
              {
                x: 0,
                y: 0,
              },
            ],
          },
        ],
      ],
      // imageCounter: 0,
      // imgs: document.images,
    };
  },
  mounted() {
    // On first load fetchen van hotspotdata
    // Wordt gedaan in dit component zodat er maar 1 call moet gebeuren voor de beide trailers.
    this.fetchHotspotData();
  },
  methods: {
    onImagesLoaded(container, event) {
      var images = container.getElementsByTagName("img");
      var loaded = images.length;
      for (var i = 0; i < images.length; i++) {
        if (images[i].complete) {
          loaded--;
        } else {
          images[i].addEventListener("load", function () {
            loaded--;
            if (loaded == 0) {
              event();
            }
          });
        }
        if (loaded == 0) {
          event();
        }
      }
    },
    fetchHotspotData() {
      axios

        .get("/" + this.langCode + "/api/hotspots")
        .then((response) => {
          if (response.status === 200) {
            // Indien er hotspots gefetched zijn
            if (response.data.length !== 0) {
              // Opsplitsen van de 2 soorten trailer typesnpm
              const arrKipper = response.data.filter(
                (val) => val.field_hotspot_id.split("_")[0] === "KIPPER"
              );
              const arrTransporter = response.data.filter(
                (val) => val.field_hotspot_id.split("_")[0] === "TRANSPORTER"
              );

              // Deze wordt meegegeven aan de 360 view element
              // Trailer[0] => kipper
              this.trailers[0].forEach((trailer) => {
                arrKipper.forEach((kipper) => {
                  if (trailer.field_hotspot_id === kipper.field_hotspot_id) {
                    trailer["title"] = kipper.title;
                    trailer["image"] = kipper.uri;
                    trailer["text"] = kipper.body;
                  }
                });
              });

              // Trailer[1] => transporter
              this.trailers[1].forEach((trailer) => {
                arrTransporter.forEach((transporter) => {
                  if (
                    trailer.field_hotspot_id === transporter.field_hotspot_id
                  ) {
                    trailer["title"] = transporter.title;
                    trailer["image"] = transporter.uri;
                    trailer["text"] = transporter.body;
                  }
                });
              });
            }

            console.log(this.trailers[1]);

            // Na fetch wachten tot alle images geladen zijn
            this.onImagesLoaded(document.getElementById("app"), () => {
              // Indien gelukt de spinner stoppen adhv onderstaande variabele
              this.fetched = true;
            });
          }
        })
        .catch((error) => {
          // TODO: Correctere error handling toevoegen
          console.error(error);
        });
    },
  },
};
</script>
<style lang="scss">
.tabs {
  width: 100%;
  box-sizing: border-box;
  margin: 2em 0;
  // Bovenste 2 tabladen
  &__actions {
    display: flex;
    justify-content: center;
    &__tab {
      cursor: pointer;
      padding: 1em;
      background-color: rgba(211, 211, 211, 0.288);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 200px;
      position: relative;
      &--icon {
        display: block;
        width: 70%;
        min-height: 50px;
        object-fit: cover;
      }
      &--degrees {
        font-size: 1.2em;
        right: 1.6em;
        top: 1em;
        position: absolute;
        margin: 0;
      }
      &:after {
        content: "";
        width: 100%;
        // left: 0;
        position: absolute;
        height: 0px;
        background-color: #1a9cab;
        top: calc(100% - 2px);
        transition: width 300ms ease-in-out;
      }
      &--left {
        border-radius: 10px 0px 0 0;
      }
      &--right {
        border-radius: 0px 10px 0 0;
      }
      &--active {
        background-color: #1a9cab;
        color: #fff;
      }
    }
  }

  // De viewer met daarin de 360 component
  &__viewer {
    width: 100%;
    border: 1px solid #1a9cab;
    position: relative;
    &--spinner {
      background-image: url("https://www.twintrailer.be/modules/custom/twin_threesixty/images/placeholder_blur.jpg");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      height: 400px;
    }
    .loader {
      position: absolute;
      top: calc(50% - 100px);
      left: calc(50% - 30px);
    }
  }
}
.hidden {
  visibility: hidden;
}

.preload {
  position: absolute;
  left: -9999px;
  top: -9999px;
}

// Alle css voor de spinner
.loader {
  color: #17646d;
  z-index: 1;
  font-size: 60px;
  text-indent: -9999em;
  overflow: hidden;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin: 72px auto;
  position: relative;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load6 1.7s infinite ease, round 1.7s infinite ease;
  animation: load6 1.7s infinite ease, round 1.7s infinite ease;
}
@-webkit-keyframes load6 {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em,
      -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em,
      -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em,
      -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em,
      -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em,
      -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em,
      -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}
@keyframes load6 {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em,
      -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em,
      -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em,
      -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em,
      -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em,
      -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em,
      -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}
@-webkit-keyframes round {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes round {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
